<template>
  <div>
    <section class="section pt-0 pl-0 pr-0">
      <h3 class="title is-6">引取</h3>
      <b-field grouped>
        <b-field label="引取先" expanded>
          <b-autocomplete
            :data="filteredAuctionSiteList"
            field="E_AuctionAreaSatellite.value"
            v-model="transportFromName"
            @select="setAuctionVendor"
            open-on-focus
            clearable
          ></b-autocomplete>
        </b-field>
      </b-field>
      <div class="columns">
        <div class="column">
          <b-field label="住所" expanded>
            <b-input v-model="yardAdressTransport"></b-input>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field label="エリア" expanded>
            <b-input v-model="yardAreaTransport"></b-input>
          </b-field>
        </div>
      </div>
    </section>

    <section class="section pt-0 pl-0 pr-0">
      <div class="columns">
        <div class="column">
          <h3 class="title is-6">納車</h3>
        </div>
        <div class="column is-4 has-text-right">
          <b-switch
            size="is-small"
            v-model="item.transportUseYardsForTransportTo"
            @input="updateUserYardsForTransportTo"
            >提携ヤードを利用する</b-switch
          >
        </div>
      </div>
      <div class="columns" v-show="item.transportUseYardsForTransportTo">
        <div class="column">
          <b-field label="提携ヤード">
            <b-autocomplete
              :data="filteredYardVendors"
              field="AREA_NAME.value"
              :value="item.transportToId"
              v-model="yardVendorInput"
              @select="setYardName"
              placeholder="Choose Yard"
              open-on-focus
              clearable
            >
            </b-autocomplete>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field label="納車先" expanded>
            <b-input
              v-model="item.transportToName"
              :disabled="item.transportUseYardsForTransportTo"
            ></b-input>
          </b-field>
          <small v-show="item.transportToRemarks" class="has-text-danger pl-3">
            <fa icon="exclamation-triangle" />
            搬入連絡：{{ item.transportToRemarks }}
          </small>
        </div>
        <div class="column is-3">
          <b-field label="連絡先" expanded>
            <b-input
              v-model="item.transportToPhone"
              :disabled="item.transportUseYardsForTransportTo"
            ></b-input>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field label="担当者" expanded>
            <b-input
              v-model="item.transportToIncharge"
              :disabled="item.transportUseYardsForTransportTo"
            ></b-input>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field label="住所" expanded>
            <b-input
              v-model="item.transportToAddress"
              :disabled="item.transportUseYardsForTransportTo"
            ></b-input>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field label="エリア" expanded>
            <b-input disabled v-model="item.transportToArea"></b-input>
          </b-field>
        </div>
      </div>
      <!--START 20230417 QuocNV add-New Item HandlingCompany  -->
      <div class="columns">
        <div class="column is-4">
          <b-field label="HANDLING COMPANY(JP)" expanded>
            <b-input v-model="item.handlingCompanyJp">
            </b-input>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field label="HANDLING COMPANY(EN)" expanded>
            <b-input
              v-model="item.handlingCompanyEn"></b-input>
          </b-field>
        </div>
      </div>
      <!--START 20230417 QuocNV add-New Item HandlingCompany  -->
    </section>

    <section class="section pt-0 pl-0 pr-0">
      <h3 class="title is-6">陸送会社</h3>
      <div class="columns">
        <div class="column">
          <b-switch size="is-small" v-model="item.controlListTransportFlg"
            >通常料金以外の入力</b-switch
          >
        </div>
      </div>
      <b-field
        label="陸送会社"
        v-if="
          item.transportUseYardsForTransportTo &&
          filteredTransportCosts.length > 0 &&
          !item.controlListTransportFlg
        "
      >
        <b-autocomplete
          key="item.transportOptionNumberPlateCut"
          :data="filteredTransportCosts"
          field="vendorName"
          :value="item.transportCostId"
          v-model="transportVendorInput"
          @select="setTransportCost"
          :loading="isFetching"
          placeholder="ヤードを選択して下さい"
          open-on-focus
          clearable
        >
          <template slot-scope="props">
            {{ props.option.vendorName }} ({{ props.option.id }})
            <br />
            <small>
              {{ props.option.totalActualCost | formatNumber }}
            </small>
            <small class="has-text-grey-light">
              ( actual: {{ props.option.actualCost | formatNumber }}, out:
              {{ props.option.outFee | formatNumber }}, cut:
              {{ props.option.numberPlateCutFee | formatNumber }}, base:
              {{ props.option.cost | formatNumber }}, a:
              {{ props.option.costA | formatNumber }}, b:
              {{ props.option.costB | formatNumber }}, c:
              {{ props.option.costC | formatNumber }}, d:
              {{ props.option.costD | formatNumber }}, e:
              {{ props.option.costE | formatNumber }}
              )
            </small>
          </template>
        </b-autocomplete>
      </b-field>
      <b-field label="陸送会社" v-else>
        <b-autocomplete
          key="0"
          :data="filteredTransportVendors"
          field="Company.value"
          :value="item.transportVendorId"
          :loading="isFetching"
          v-model="transportVendorInput"
          @select="setTransportVendor"
          open-on-focus
          clearable
        />
      </b-field>
      <div class="field platecut-section" v-show="item.hasNumberPlate"
          :class="item.transportToId == 'JC NODA YARD. NODA' && 
          (item.customerId === '000003' || item.customerId === '000088') ? 'disable' : ''">
        <div>
          <fa icon="exclamation-triangle" />
          ナンバー付き車両、カット
        </div>
        <b-radio
          name="transportOptionNumberPlateCut"
          :native-value="true"
          :disabled="item.numberPlatePickUp"
          v-model="item.transportOptionNumberPlateCut"
          @input="updateTransportOptionNumberPlateCut"
          >依頼する</b-radio
        >
        <b-radio
          name="transportOptionNumberPlateCut"
          :native-value="false"
          :disabled="item.numberPlatePickUp"
          v-model="item.transportOptionNumberPlateCut"
          @input="updateTransportOptionNumberPlateCut"
          >そのまま</b-radio
        >
      </div>
      <div  v-if ="item.numberPlatePickUp" class="field">
        ※ナンバープレート現地回収済み
      </div>
      <div class="field">
        <b-field label="陸送会社への連絡事項">
          <b-input type="textarea" v-model="item.transportRemarks"></b-input>
        </b-field>
      </div>
      <div class="field" v-if="item.hasNumberPlate">
        <b-field label="ナンバー送付先住所">
          <b-input
            type="textarea"
            v-model="item.numberDeliveryAddress"
            :disabled="isBookedItem"
            :rows="1"
          ></b-input>
        </b-field>
      </div>

      <b-field class="field" v-if="item.hasNumberPlate">
      <b-checkbox v-model="item.requestVehicleNumberCut" 
      @input="checkBoxNumberDeliveryAddress"
      :disabled="isBookedItem || !item.transportOptionNumberPlateCut"
        >ナンバー送付先をジャパンキャリアーに変更する</b-checkbox
      >
    </b-field>

      <div class="columns">
        <div class="column">
          <b-button @click="showCalendar">搬入期限の依頼補記</b-button>
          <b-datepicker
            v-if="isShow"
            :inline="true"
            v-model="deliveryDeadline"
            @input="updateDeliveryDeadline"
          >
          </b-datepicker>
        </div>
        <div class="column"></div>
        <div class="column"></div>
        <div class="column"></div>
      </div>
      <div class="columns">
        <div class="column">
          <b-checkbox v-model="item.requestDeleteAuctionFlg" type="is-info"
            >オークション会場に抹消依頼済</b-checkbox
          >
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <b-field
              label="陸送費（実費）"
              :type="listErrType.errCost"
              :message="listMsgValidation.msgCost"
            >
              <b-input
                :disabled = "item.transportRequestDate != ''"
                v-model="item.transportActualCost"
                @input="validationInput"
              ></b-input>
            </b-field>
          </div>
        </div>
        <div class="column">
          <b-field label="搬出費">
            <b-input v-model.number="item.transportOutFee" disabled></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="ナンバーカット">
            <b-input
              v-model.number="item.transportNumberPlateCutFee"
              disabled
            ></b-input>
          </b-field>
        </div>
        <div class="column">
          <div class="field">
            <b-field label="費用合計">
              <b-input
                v-model.number="item.transportTotalActualCost"
                disabled
              ></b-input>
            </b-field>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <b-field
              label="陸送費（請求）"
              :type="listErrType.errTransportCost"
              :message="listMsgValidation.msgTransportCost"
            >
              <b-input
                v-model.number="item.transportCost"
                :disabled = "item.invoiceIsuueDate != ''"
                @input="validationInput"
                :class="{'checkFee':((+item.transportActualCost > +item.transportCost) && item.dateConfirmFeeTransport =='')}"
              ></b-input>
            </b-field>
          </div>
        </div>
        <div class="column">
          <div class="field jc-select-option">
            <b-field label="通常料金以外の事由">
              <b-select
                class="jc-select-option"
                expanded
                v-model="item.regularCharge"
                :disable="checkEditPrice"
              >
                <option class="selected" value="">ー</option>
                <option value="サイズのため">サイズのため</option>
                <option value="不動（フォークリフト使用）">
                  不動（フォークリフト使用）
                </option>
                <option value="不動（足回りOK）">不動（足回りOK）</option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <b-field label="請求合計">
              <b-input
                v-model.number="item.transportTotalCost"
                disabled
                :class="{'checkFee':((item.transportTotalActualCost > item.transportTotalCost) && item.dateConfirmFeeTransport =='')}"
              ></b-input>
            </b-field>
          </div>
        </div>
      </div>
      <div class="columns">
        <!-- <div class="column">
          <b-field label="請求書確認日">
            <b-datepicker
              icon="calendar-day"
              position="is-top-right"
              editable
              v-model="transportRequestDate"
              @input="updateTransportRequestDate"
              :min-date="todate"
            />
          </b-field>
        </div> -->
        <div class="column is-4">
          <b-field label="手配完了日">
            <b-datepicker
              icon="calendar-day"
              position="is-top-right"
              editable
              :disabled = "item.invoiceIsuueDate != ''"
              v-model="transportRequestConfirmDate"
              @input="updateTransportRequestConfirmDate"
              :min-date="todate"
            />
          </b-field>
        </div>
        <div class="column is-4">
          <b-field label="納車予定日">
            <b-datepicker
              icon="calendar-day"
              position="is-top-right"
              editable
              v-model="transportEstimatedArrivalDate"
              @input="updateTransportEstimatedArrivalDate"
              :min-date="todate"
            />
          </b-field>
        </div>
      </div>
      <!-- START QuocNV 20231115 add new item  -->
      <div class="columns">
        <div class="column is-4">
          <b-field label="陸送費確認日">
            <b-datepicker
              icon="calendar-day"
              position="is-top-right"
              editable
              :disabled = "!isBookedItem && item.status!=2"
              v-model="dateConfirmFeeTransport"
              @input="updateDateConfirmFeeTransport"
            />
          </b-field>
        </div>
        <div class="column is-4">
          <b-field label="陸送費確認者">
            <input
                class="input-text"
                disabled
                v-model="item.userConfirmFeeTransport"
              />
          </b-field>
        </div>
      </div>
      <!-- END QuocNV 20231115 add new item  -->
      <div class="columns">
        <div class="column is-4">
          <b-field label="請求書確認日">
            <b-datepicker
              icon="calendar-day"
              position="is-top-right"
              editable
              v-model="transportRequestDate"
              @input="updateTransportRequestDate"
              :min-date="todate"
            />
          </b-field>
        </div>

        <div class="column is-4">
          <b-field label="請求書作成日">
            <b-datepicker
              icon="calendar-day"
              position="is-top-right"
              editable
              :disabled = "!isBookedItem && item.status!=2"
              v-model="invoiceIsuueDate"
              @input="updateInvoiceIsuueDate"
            />
          </b-field>
        </div>
      </div>
      <div class="field">
        <b-field label="備考">
          <b-input type="textarea" v-model="item.transportNote"></b-input>
        </b-field>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <b-field label="ヤード確定日">
              <b-input disabled v-model="item.yardConfirmationDate"></b-input>
            </b-field>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <b-field label="ヤード確定者">
              <input class="input-text" disabled v-model="item.yardConfirmed" />
            </b-field>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <b-field label="陸送手配日">
              <b-input
                disabled
                v-model="item.landTransportationArrangementDate"
              ></b-input>
            </b-field>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <b-field label="陸送手配者">
              <input
                class="input-text"
                disabled
                v-model="item.landTransportationArranger"
              />
            </b-field>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div
            class="column-save"
            @click="saveTransport()"
            v-if="
              item.conditionChecked &&
              item.transportToName != '' &&
              item.transportVendorId != ''
            "
          >
            <b-button class="is-size-7 btn-save" label="保存" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style scoped>
.platecut-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 20px 0;
  padding: 1rem;
  border: 1px solid #f59b2c;
  border-radius: 3px;
  background-color: #fff5e8;
}
.platecut-section svg {
  color: #f59b2c;
}
.jc-select-option {
  min-height: 40px;
}
.jc-select-option:hover {
  border-color: #b5b5b5;
}
.selected {
  text-align: center;
}
.input-text {
  min-height: 40px;
  box-sizing: border-box;
  clear: both;
  font-size: 1rem;
  position: relative;
  text-align: inherit;
  border-radius: 4px;
  background-color: #f5f5f5;
  border-color: #f5f5f5;
  box-shadow: none;
  color: #7a7a7a;
  cursor: not-allowed;
  max-width: 100%;
  width: 100%;
  align-items: center;
  border: 1px solid transparent;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.5em - 1px);
  padding-left: calc(0.75em - 1px);
  padding-right: calc(0.75em - 1px);
  padding-top: calc(0.5em - 1px);
  vertical-align: top;
  text-overflow: ellipsis;
}
.column button {
  font-size: 15px;
}
.column-save {
  margin: 1px 0px 0px 5px;
  text-align: center;
}
.btn-save {
  width: 80px;
  font-size: 15px !important;
  height: 32px;
  background-color: #2d70d3;
  color: #fff;
}
.disable{
  pointer-events: none;
  opacity: 0.5;
}

</style>
<style>
.checkFee .input {
  background-color: red !important;
  font-weight: 700;
  color: #363636 !important;
}
</style>
<script>
import moment from 'moment';
const DATE_FORMAT = 'YYYY-MM-DD';
const constDeliveryString = '※MM/ddまでの搬入をお願いします。';
const regexFormatNumber = /^[0-9]+$/;
export default {
  props: [
    'item',
    'yards',
    'transportCosts',
    'isFetching',
    'transportVendors',
    'selectedAuctionVendor',
    'auctions',
  ],
  data: () => ({
    yardVendorInput: '',
    transportVendorInput: '',
    transportRequestDate: null,
    invoiceIsuueDate: null,
    transportRequestConfirmDate: null,
    transportEstimatedArrivalDate: null,
    selectedVendor: null,
    selectedCost: null,
    todate: {},
    auctionVendorInput: '',
    yardTransportId: ',',
    isShow: false,
    deliveryDeadline: null,
    transportFromName: '',
    yardAdressTransport: '',
    yardAreaTransport: '',
    isEdit: false,
    listMsgValidation: {
      errCost: '',
      errTransportCost: '',
    },
    listErrType: {
      msgCost: '',
      msgTransportCost: '',
    },
    dateConfirmFeeTransport: null,
  }),
  created() {
    this.isEdit = false;
    this.todate = moment(this.item.orderDate, DATE_FORMAT)
      .add(1, 'days')
      .toDate();
    this.yardVendorInput = this.item.transportToId || '';
    this.transportVendorInput = this.item.transportVendorName || '';
    this.yardTransportId = this.item.yardTransportId;
    this.transportFromName = this.item.transportFromId || '';
    this.yardAdressTransport = this.item.yardAdressTransport || '';
    this.yardAreaTransport = this.item.yardAreaTransport || '';
    this.item.hasNumberPlate = false;
    if (this.item.transportRequestDate != '') {
      this.transportRequestDate = moment(
        this.item.transportRequestDate,
        DATE_FORMAT
      ).toDate();
    }

    if (this.item.invoiceIsuueDate != '') {
      this.invoiceIsuueDate = moment(
        this.item.invoiceIsuueDate,
        DATE_FORMAT
      ).toDate();
    }

    if (this.item.transportRequestConfirmDate != '') {
      this.transportRequestConfirmDate = moment(
        this.item.transportRequestConfirmDate,
        DATE_FORMAT
      ).toDate();
    }

    if (this.item.transportEstimatedArrivalDate != '') {
      this.transportEstimatedArrivalDate = moment(
        this.item.transportEstimatedArrivalDate,
        DATE_FORMAT
      ).toDate();
    }

    if (this.item.dateConfirmFeeTransport != '') {
      this.dateConfirmFeeTransport = moment(
        this.item.dateConfirmFeeTransport,
        DATE_FORMAT
      ).toDate();
    }
    
  },
  computed: {
    filteredYardVendors() {
      return this.yards.filter(
        (option) =>
          option.AREA_NAME.value
            .toUpperCase()
            .indexOf(this.yardVendorInput.toUpperCase()) >= 0
      );
    },
    filteredTransportVendors() {
      return this.transportVendors.slice().sort((a, b) => a.Company.value.localeCompare(b.Company.value)).filter(
        (option) =>
          option.Company.value
            .toUpperCase()
            .indexOf(this.transportVendorInput.toUpperCase()) >= 0
      );
    },
    transportCostsWithExtraFees() {
      return this.transportCosts
        .map((c) => {
          c.numberPlateCutFee = 0;
          const vendor = this.transportVendors.find(
            (v) => v.TransporterID.value == c.vendorId
          );
          c.outFee = this.calcTransportOutFee(
            c.vendorName,
            this.selectedAuctionVendor
          );
          c.numberPlateCutFee = +vendor.NumberPlateCutFee.value || 0;
          //START QuocNV 20230705 add cut fee 1500 of company
          if((c.vendorName == 'ゼロ' || c.vendorName =='ゼロ（燃料調整費込）') && this.item.hasNumberPlate && this.item.transportOptionNumberPlateCut){
            c.numberPlateCutFee += 1500;
          }
          //END QuocNV 20230705 add cut fee 1500 of company
          c.totalActualCost = c.actualCost + c.outFee + c.numberPlateCutFee;
          return c;
        })
        .sort((a, b) => {
          let x = a.actualCost + a.outFee;
          let y = b.actualCost + b.outFee;
          if (this.item.transportOptionNumberPlateCut) {
            x += a.numberPlateCutFee;
            y += b.numberPlateCutFee;
          }
          return x > y ? 1 : -1;
        });
    },
    filteredTransportCosts() {
      return this.transportCostsWithExtraFees.filter(
        (option) =>
          option.vendorName
            .toUpperCase()
            .indexOf(this.transportVendorInput.toUpperCase()) >= 0
      );
    },
    filteredAuctionSiteList() {
      return this.auctions.filter(
        (option) =>
          option.E_AuctionAreaSatellite.value
            .toUpperCase()
            .indexOf(this.transportFromName.toUpperCase()) >= 0
      );
    },
  },
  watch: {
    'item.transportRequestDate': function () {
      if (!this.item.transportRequestDate) {
        this.transportRequestDate = null;
      }
    },
    'item.invoiceIsuueDate': function () {
      if (!this.item.invoiceIsuueDate) {
        this.invoiceIsuueDate = null;
      }
    },
    'item.transportFromId': function () {
      this.isEdit = true;
      this.yardTransportId = this.item.transportFromId;
      this.transportFromName = this.item.transportFromId;
      this.yardAdressTransport = this.item.yardAdressTransport;
      this.yardAreaTransport = this.item.yardAreaTransport;
    },
    'item.transportRequestConfirmDate': function () {
      if (!this.item.transportRequestConfirmDate) {
        this.transportRequestConfirmDate = null;
      }
    },
    'item.transportEstimatedArrivalDate': function () {
      if (!this.item.transportEstimatedArrivalDate) {
        this.transportEstimatedArrivalDate = null;
      }
    },
    'item.dateConfirmFeeTransport': function () {
      if (!this.item.dateConfirmFeeTransport) {
        this.dateConfirmFeeTransport = null;
      }
    },
    'item.orderDate': function () {
      this.todate = moment(this.item.orderDate, DATE_FORMAT)
        .add(1, 'days')
        .toDate();
    },
    'item.transportOptionNumberPlateCut': function () {
      if (
        this.item.transportUseYardsForTransportTo &&
        this.filteredTransportCosts.length > 0
      ) {
        this.setTransportCost(this.selectedCost);
      } else {
        this.setTransportVendor(this.selectedVendor);
      }
    },

    isFetching: function () {
      if (!this.isFetching && this.isEdit) {
        if (this.filteredTransportCosts.length > 0) {
          this.item.controlListTransportFlg = false;
        } else {
          this.item.controlListTransportFlg = true;
        }
      } else if (!this.isFetching) {
        this.isEdit = true;
      }
    },
    transportFromName: function () {
      if (this.isEdit) {
        const auction = this.auctions.find(
          (v) => v.E_AuctionAreaSatellite.value == this.transportFromName
        );
        this.item.transportFromName = this.item.yardTransportName = auction
          ? auction.AuctionArea.value
          : this.transportFromName;
        this.item.yardTransportId = this.transportFromName;
      }
      this.isEdit = true;
    },
    yardAdressTransport: function () {
      if (this.isEdit) {
        this.item.yardAdressTransport = this.yardAdressTransport;
      }
    },
    yardAreaTransport: function () {
      if (this.isEdit) {
        this.item.yardAreaTransport = this.yardAreaTransport;
      }
    },
    selectedAuctionVendor: function () {
      this.isEdit = true;
      this.setTransportVendor(null);
      this.setTransportCost(null);
    },
  },
  methods: {
    updateUserYardsForTransportTo() {
      this.setYardName(null);
      this.setTransportCost(null);
    },
    setYardName(yard) {
      this.isEdit = true;
      if (!yard || yard.AREA_NAME.value != this.item.transportToId) {
        this.setTransportCost(null);
      }
      this.yardVendorInput = yard ? yard.AREA_NAME.value : '';
      this.item.transportToId = yard ? yard.AREA_NAME.value : '';
      this.item.transportToName = yard ? yard.YardName.value : '';
      this.item.transportToAddress = yard ? yard.Address.value : '';
      this.item.transportToArea = yard ? yard.AREA.value : '';
      this.item.transportToRemarks = yard
        ? yard.Delivery_Confirmation.value
        : '';
      this.item.transportToPhone = yard ? yard.Telephone.value : '';
      this.item.transportToIncharge = yard ? yard.Incharge.value : '';
      if (yard) {
        if (yard.Yard_Category.value == '1'){
        this.item.yardId = yard.Yard_Record_Id.value;
        } else {
        this.item.yardId = yard.Yard_City.value;
        }
      } else {
        this.item.yardId = '';
      }
      
      this.item.yardIdTemp = yard ? yard.Yard_Record_Id.value: '';
      //START QuocNV 20230517 update source transport 2++
      // this.item.yardId = yard ? yard.Yard_Record_Id.value: '';
      this.item.handlingCompanyEn = yard ? yard.handling_company_en.value : '';
      this.item.handlingCompanyJp = yard ? yard.handling_company_jp.value : '';
      this.item.yardCategory = yard ? yard.Yard_Category.value : '';
      //END QuocNV 20230517 update source transport 2++
      this.item.yardCity1 = yard ? yard.Yard_City_Name.value : '';
      this.$emit('calc');
    },
    calcTransportOutFee(vendorName, from) {
      if (!vendorName || !from) return 0;
      if (
        from.AA_ID.value.startsWith('LUM') &&
        vendorName != 'ロジコ' && vendorName != 'グリーンネット'  //LOGICO
      ) {
        return 1500;
      }
      return 0;
    },
    calcTotalCost() {
      const totalActualCost =
        +this.item.transportActualCost +
        +this.item.transportOutFee +
        +this.item.transportNumberPlateCutFee;
      const totalCost =
        +this.item.transportCost + +this.item.transportOutFee + +this.item.transportNumberPlateCutFee;
      this.item.transportTotalActualCost = !isNaN(totalActualCost)
        ? totalActualCost
        : 0;
      this.item.transportTotalCost = !isNaN(totalCost) ? totalCost : 0;
    },
    setTransportVendor(vendor) {
      if (this.isEdit) {
        this.selectedVendor = vendor;
        this.transportVendorInput = vendor ? vendor.Company.value : '';
        this.item.transportVendorId = vendor ? vendor.TransporterID.value : '';
        this.item.transportVendorName = vendor ? vendor.Company.value : '';
        this.item.transportOutFee = this.calcTransportOutFee(
          this.item.transportVendorName,
          this.selectedAuctionVendor
        );
        this.item.transportNumberPlateCutFee =
          vendor && this.item.transportOptionNumberPlateCut
            ? +vendor.NumberPlateCutFee.value
            : 0;
        //START QuocNV 20230705 add cut fee 1500 of company
        if(vendor){
          if((vendor.Company.value == 'ゼロ' || vendor.Company.value =='ゼロ（燃料調整費込）') && this.item.hasNumberPlate && this.item.transportOptionNumberPlateCut){
            this.item.transportNumberPlateCutFee += 1500;
          }
          if(vendor.Company.value=='客手配'){
            this.item.transportActualCost = 0;
            this.item.transportCost = 0;
          }
        }
        
        //END QuocNV 20230705 add cut fee 1500 of company
        
        //start feature add value checkbox 1.8 or 2.3
        if(vendor && (this.item.priceSize18 || this.item.priceSize23)){
            if(this.item.transportActualCost && this.item.priceSize23){
              this.item.transportActualCost = +this.item.transportActualCost * +vendor.priceSize23.value;
              this.calcTotalCost();
            }else if(this.item.transportActualCost && this.item.priceSize18){
              this.item.transportActualCost = +this.item.transportActualCost * +vendor.priceSize18.value;
              this.calcTotalCost();
            }
        }
        //end feature add value checkbox 1.8 or 2.3
        this.calcTotalCost();
      }
    },
    setTransportCost(cost) {
      if (this.isEdit) {
        this.selectedCost = cost;
        this.transportVendorInput = cost ? cost.vendorName : '';
        this.item.transportPlan = cost ? 'A' : '';
        this.item.transportPlanFee = cost ? +cost.costA : 0;
        this.item.transportVendorId = cost ? cost.vendorId : '';
        this.item.transportVendorName = cost ? cost.vendorName : '';
        this.item.transportCostId = cost ? cost.id : '';
        this.item.transportActualCost = cost ? +cost.actualCost : 0;
        this.item.transportOutFee = this.calcTransportOutFee(
          this.item.transportVendorName,
          this.selectedAuctionVendor
        );
        this.item.transportNumberPlateCutFee =
          cost && this.item.transportOptionNumberPlateCut
            ? cost.numberPlateCutFee
            : 0;
        this.item.transportCost = cost ? +cost.costA : 0;
        if(cost){
          if(cost.vendorName=='客手配'){
            this.item.transportActualCost = 0;
            this.item.transportCost = 0;
          }
        }
        this.calcTotalCost();
      }
      this.isEdit = true;
    },
    updateTransportRequestDate() {
      this.item.transportRequestDate = this.transportRequestDate
        ? moment(this.transportRequestDate).format(DATE_FORMAT)
        : '';
    },
    updateInvoiceIsuueDate() {
      this.item.invoiceIsuueDate = this.invoiceIsuueDate
        ? moment(this.invoiceIsuueDate).format(DATE_FORMAT)
        : '';
    },
    updateTransportRequestConfirmDate() {
      this.item.transportRequestConfirmDate = this.transportRequestConfirmDate
        ? moment(this.transportRequestConfirmDate).format(DATE_FORMAT)
        : '';
    },
    updateTransportEstimatedArrivalDate() {
      this.item.transportEstimatedArrivalDate = this
        .transportEstimatedArrivalDate
        ? moment(this.transportEstimatedArrivalDate).format(DATE_FORMAT)
        : '';
    },
    setAuctionVendor(auction) {
      this.item.yardTransportId = auction ? auction.AA_ID.value : '';
      this.item.yardTransportName = auction
        ? auction.AuctionAreaSatellite.value
        : '';
      this.item.yardAdressTransport = auction ? auction.Address.value : '';
      this.item.yardAreaTransport = auction ? auction.Big_Area.value : '';
      this.$emit('auctionVendorChangedTransport', auction);
    },
    showCalendar() {
      this.isShow = !this.isShow;
    },
    updateDeliveryDeadline() {
      this.transportEstimatedArrivalDate = moment(
        this.deliveryDeadline,
        DATE_FORMAT
      ).toDate();
      this.updateTransportEstimatedArrivalDate();
      this.isShow = !this.isShow;
      const regex = /(※.*?。)/;
      const splitItems = this.item.transportRemarks.split(regex);
      let arr = [];
      for (let i = 0; i < splitItems.length; i++) {
        if (regex.test(splitItems[i])) {
          arr.push(splitItems[i]);
        }
      }
      if (arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          this.item.transportRemarks = this.item.transportRemarks.replace(
            arr[i],
            constDeliveryString.replace(
              'MM/dd',
              moment(this.deliveryDeadline).format('MM/DD')
            )
          );
        }
      } else {
        this.item.transportRemarks =
          this.item.transportRemarks +
          '\r\n' +
          String(constDeliveryString).replace(
            'MM/dd',
            moment(this.deliveryDeadline).format('MM/DD')
          );
      }
    },
    updateYardConfirmationDate() {
      this.item.yardConfirmationDate = this.transportEstimatedArrivalDate
        ? moment(this.transportEstimatedArrivalDate).format(DATE_FORMAT)
        : '';
    },
    updateLandTransportationArrangementDate() {
      this.item.landTransportationArrangementDate = this
        .landTransportationArrangementDate
        ? moment(this.landTransportationArrangementDate).format(DATE_FORMAT)
        : '';
    },
    validationInput() {
      this.item.transportActualCost = String(this.item.transportActualCost)
        .replace('.', '')
        .replace(',', '');
      this.item.transportCost = String(this.item.transportCost)
        .replace('.', '')
        .replace(',', '');
      if (regexFormatNumber.test(this.item.transportActualCost)) {
        this.listErrType.errCost = '';
        this.listMsgValidation.msgCost = '';
        this.calcTotalCost();
      } else {
        this.listErrType.errCost = 'is-danger';
        this.listMsgValidation.msgCost =
          '数字以外の文字が入力されています。数字以外は「,」のみ有効です。';
      }
      if (regexFormatNumber.test(this.item.transportCost)) {
        this.listErrType.errTransportCost = '';
        this.listMsgValidation.msgTransportCost = '';
        this.calcTotalCost();
      } else {
        this.listErrType.errTransportCost = 'is-danger';
        this.listMsgValidation.msgTransportCost =
          '数字以外の文字が入力されています。数字以外は「,」のみ有効です。';
      }
      this.$emit('responeValidateTransportAsTransport', this.listMsgValidation);
    },
    saveTransport() {
      this.$emit('saveTransport');
    },
    updateDateConfirmFeeTransport() {
      this.item.dateConfirmFeeTransport = this.dateConfirmFeeTransport
        ? moment(this.dateConfirmFeeTransport).format(DATE_FORMAT)
        : '';
    },
    updateTransportOptionNumberPlateCut() {
    if (this.item.hasNumberPlate && this.item.transportOptionNumberPlateCut) {
        this.listCustomerInf = this.$store.state.listCustomerInf;
        if (this.listCustomerInf.length > 0) {
            let findCust = this.listCustomerInf.find(x => x.customer_id_format === this.item.customerId);
            this.item.numberDeliveryAddress = findCust && findCust.address_3 ? findCust.address_3 : '';
            this.item.transportRemarks = 'ナンバー送付先：'+this.item.numberDeliveryAddress;
        }
    } else {
      this.item.transportRemarks = this.item.transportRemarks ? this.item.transportRemarks.replace(/ナンバー送付先：/g, '').replace(this.item.numberDeliveryAddress, '') : '';
      this.item.numberDeliveryAddress = '';
      this.item.requestVehicleNumberCut = false;
      this.item.numberDeliveryAddress = '';
     }
    if (this.item.requestVehicleNumberCut) {
        this.item.transportRemarks = 'ナンバー送付先：ジャパンキャリアー/135-0044　東京都江東区越中島1-2-13-7Ｆ';
        this.item.numberDeliveryAddress = 'ジャパンキャリアー/135-0044　東京都江東区越中島1-2-13-7Ｆ';
    }
    },
    checkBoxNumberDeliveryAddress() {
    if (this.item.requestVehicleNumberCut) {
        this.item.transportRemarks = 'ナンバー送付先：ジャパンキャリアー/135-0044　東京都江東区越中島1-2-13-7Ｆ';
        this.item.numberDeliveryAddress = 'ジャパンキャリアー/135-0044　東京都江東区越中島1-2-13-7Ｆ';
    } else {
        this.item.transportRemarks = this.item.transportRemarks.replace(/ナンバー送付先：ジャパンキャリアー\/135-0044　東京都江東区越中島1-2-13-7Ｆ/g, '');
        this.updateTransportOptionNumberPlateCut();
    }
    },
  },
};
</script>
